// Phase 60.3 follow-up: multi-pill renderer for a lead's campaign membership.
// Renders three independent pills:
//   1. Campaign name (always)
//   2. Progress N/M when total is known, or "шаг N" when only step is known
//   3. "ответил" green badge when recipient.repliedAt is non-null
//
// Each pill is its own visual chip — easier to scan than a single concatenated string.
//
// DESIGN SYSTEM (BLOGGER-CARD-DS 2026-08-18, spec P3). Card-exclusive child of the Инфо
// tab (single importer LeadDetailsInfoTab.jsx — spec S1 corrects the context extract's
// claim of a second BloggersView consumer), so it migrates with that tab: the three
// hand-rolled pill style objects — and with them the three raw hex literals the
// adherence gate flagged — become DS Badge call sites through the barrel (purple /
// neutral / green on the contained tier), and the wrapper's layout moves onto an
// oc-lead-card__ class in components/lead-card.css.
//
// The migration is presentation-only (fixed point F3): both variants, the progress
// derivation and every RU string are carried over unchanged.
import React from 'react';
import { Badge } from './ds';

export default function CampaignPills({ campaign, variant = 'full' }) {
  if (!campaign) return null;
  const { name, currentStage, totalStages, responded } = campaign;

  // Compact list-column variant: just the campaign name pill, nothing else.
  // Used in BloggersView so the column stays narrow and easy to scan.
  if (variant === 'name-only') {
    return (
      <div className="oc-lead-card__campaign-pills" title={name || ''}>
        <Badge color="purple" type="contained" size="small">{name || '—'}</Badge>
      </div>
    );
  }

  // Full variant (default): name + progress + responded badges, used in
  // LeadDetailsModal where vertical space is available.
  let progressLabel = null;
  if (typeof totalStages === 'number' && totalStages > 0) {
    // Always render the denominator — even if currentStage is null (just queued).
    const stageNum = typeof currentStage === 'number' && currentStage >= 0 ? currentStage : 0;
    progressLabel = `${stageNum}/${totalStages}`;
  } else if (typeof currentStage === 'number' && currentStage > 0) {
    progressLabel = `шаг ${currentStage}`;
  }

  return (
    <div className="oc-lead-card__campaign-pills" title={name || ''}>
      <Badge color="purple" type="contained" size="small">{name || '—'}</Badge>
      {progressLabel && <Badge color="neutral" type="contained" size="small">{progressLabel}</Badge>}
      {responded && <Badge color="green" type="contained" size="small">ответил</Badge>}
    </div>
  );
}
